import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { useState } from 'react'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { CATALOG_BASE_PATH } from '@/const'
import { useNavigate, useSearchParams } from 'react-router'
import { MdTextAction } from '../types'
import { useCatalogComponentRuntime } from '../../shared/CatalogComponentRuntimeContext'

export function ActionWithConfirmDialog({
  action,
  markdown,
  reloadHandler,
}: {
  action: MdTextAction
  markdown: string
  reloadHandler: () => void
}) {
  const handlerId = action.handlerId || ''
  const actionId = action.id || ''
  const emptyTileFilterSelections: Record<string, unknown>[] = []
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [searchParams] = useSearchParams()
  const { allowRouteNavigation = true } = useCatalogComponentRuntime()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(
    handlerId,
    emptyTileFilterSelections,
    actionId,
    {
      onSuccess: () => setIsOpen(false),
    }
  )

  if (!handlerId) {
    console.error('No handlerId provided for action:', action)
    return null
  }

  if (action.type === 'navigate' && !allowRouteNavigation) {
    return (
      <div className="flex items-center gap-2 text-muted-foreground">
        <DynamicIcon
          iconName={action.icon || ''}
          lazyLoad={false}
          className="size-3"
          fallback={<div className="size-4" />}
        />
        <span>{action.label}</span>
      </div>
    )
  }

  const onConfirm = () => {
    if (action.type === 'navigate') {
      navigate(`${CATALOG_BASE_PATH}${handlerId}?${searchParams.toString()}`)
      return
    }
    if (action.type === 'reload') {
      reloadHandler()
      return
    }
    submitForm({ data: markdown })
  }

  return (
    <ConfirmDialog
      trigger={
        <div className="flex items-center gap-2">
          <DynamicIcon
            iconName={action.icon || ''}
            lazyLoad={false}
            className="size-3"
            fallback={<div className="size-4" />}
          />
          <span>{action.label}</span>
        </div>
      }
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      title={action.label}
      description={action.confirmationMessage}
      onConfirm={onConfirm}
      closeOnConfirm={false}
      isSubmitting={isSubmitting}
    />
  )
}
